import { render, staticRenderFns } from "./BigTop.vue?vue&type=template&id=6f8d80fc&scoped=true&"
import script from "./BigTop.vue?vue&type=script&lang=ts&"
export * from "./BigTop.vue?vue&type=script&lang=ts&"
import style0 from "./BigTop.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BigTop.vue?vue&type=style&index=1&id=6f8d80fc&scoped=true&lang=sass&"
import style2 from "./BigTop.vue?vue&type=style&index=2&id=6f8d80fc&scoped=true&lang=sass&"
import style3 from "./BigTop.vue?vue&type=style&index=3&id=6f8d80fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d80fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VRow,VSheet})
